import React from "react";
import "../Leadership/LeaderBuildWithUs.css";
import bgGradient from "../../Assets/rock-bg.png";
import handsImage from "../../Assets/health/image 79.png";

const HealthBuildWithUs = () => {
  return (
    <section className="build-with-us">
      {/* <img src={bgGradient} alt="Background" className="build-bg" /> */}

      <div className="build-content-wrapper">
        {/* <h2 className="build-heading">VCNR HEALTHCARE</h2> */}

        <div className="build-box">
          <div className="text-content">
            <h3>VCNR HEALTHCARE</h3>
            <p>
              continues to evolve, but one thing remains constant—our unwavering focus on people. As we scale services across India, we remain deeply rooted in compassion, community, and care that transforms lives.
            </p>
            <button className="build-partner-btn" onButtonClick={() => navigate("/Contact")}>Partner With Our Group</button>
          </div>

          <div className="image-content1">
            <img src={handsImage} alt="Hands Raised" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HealthBuildWithUs;
